module.exports = __webpack_public_path__ + "static/grafika5-aba5915f23d217bf16bfd534352c6a65.png";